import { api, getWithOptionalAuthorization, postWithOptionalAuthorization } from './api';
import { getToken } from './auth';
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { decryptMessage } from '../utils/decrypt';
import { IMPORT_EXPORT_BASE } from './apiConstant';
import { CityExportParams, POIExportParams, TripPOIExportParams, ErrorReportParams } from './importExportTypes';

const importExportApi = {

  importCity: async (body: FormData): Promise<AxiosResponse<any>> => {
    try {    
      const cityResponse = await postWithOptionalAuthorization(`${IMPORT_EXPORT_BASE}/CityTemplateUpload`, body, true, true);
      return cityResponse;
    } catch (error) {
      console.error('Error importing city : ', error);
      throw error;
    }
  },

  importPOI: async (body: FormData): Promise<AxiosResponse<any>> => {
    try {
      const POIResponse = await postWithOptionalAuthorization(`${IMPORT_EXPORT_BASE}/RegionPOITemplateUpload`, body, true, true);
      return POIResponse;
    } catch (error) {
      console.error('Error importing POI : ', error);
      throw error;
    }
  },

  importTripPOI: async (body: FormData): Promise<AxiosResponse<any>> => {
    try {
      const tripPOIResponse = await postWithOptionalAuthorization(`${IMPORT_EXPORT_BASE}/TripPOITemplateUpload`, body, true, true);
      return tripPOIResponse;
    } catch (error) {
      console.error('Error importing Trip POI : ', error);
      throw error;
    }
  },

  exportCity: async (body: CityExportParams): Promise<AxiosResponse<Blob>> => {
    try {    
      const exportCityResponse = await postWithOptionalAuthorization(`${IMPORT_EXPORT_BASE}/CityTemplateExport`, 
        body, 
        true, 
        false, 
        {
        responseType: 'blob',
        });
      return exportCityResponse;
    } catch (error) {
      console.error('Error exporting city : ', error);
      throw error;
    }
  },

  exportPOI: async (body: POIExportParams): Promise<AxiosResponse<Blob>> => {
    try {
      const exportPOIResponse = await postWithOptionalAuthorization(`${IMPORT_EXPORT_BASE}/RegionPOITemplateExport`, 
        body, 
        true, 
        false, 
        {
        responseType: 'blob',
        });
      return exportPOIResponse;
    } catch (error) {
      console.error('Error exporting POI : ', error);
      throw error;
    }
  },

  exportTripPOI: async (body: TripPOIExportParams): Promise<AxiosResponse<Blob>> => {
    try {
      const exportTripPOI = await postWithOptionalAuthorization(`${IMPORT_EXPORT_BASE}/TripPOITemplateExport`, 
        body, 
        true, 
        false, 
        {
        responseType: 'blob',
        });
      return exportTripPOI;
    } catch (error) {
      console.error('Error exporting Trip POI : ', error);
      throw error;
    }
  },

  exportImportErrorReport: async (body: ErrorReportParams): Promise<AxiosResponse<any>> => {
    try {    
      const errorReporthResponse = await postWithOptionalAuthorization(`${IMPORT_EXPORT_BASE}/ExportErrorReport`, 
        body, 
        true, 
        false, 
        {
        responseType: 'blob',
        });
      return errorReporthResponse;
    } catch (error) {
      console.error('Error ImportErrorReport: ', error);
      throw error;
    }
  },
};

export default importExportApi;
